export const API_URL =
  process.env.REACT_APP_ENV === 'dev'
    ? 'https://api.beta.tipsterchat.com'
    : 'https://api.tipsterchat.com';
